import withRoot from '../../withRoot';
import React, {useState, useEffect, Fragment, useContext} from 'react';
import {
    Button,
    Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle,
    Slide, Snackbar,
} from '@material-ui/core';
import {Table, Popover, Dropdown, Whisper} from 'rsuite';
import Axios from "axios";
import SearchIcon from '@material-ui/icons/Search';
import TextField from "@material-ui/core/TextField/TextField";
import {gql, useLazyQuery, useMutation} from "@apollo/client";
import {useFormik} from "formik";
import * as yup from 'yup';
import {makeStyles} from "@material-ui/core/styles";
import Loading from "../../Loading";
import Alert from "@material-ui/lab/Alert";
import ArrowDropDownCircleIcon from "@material-ui/icons/ArrowDropDownCircle";
import authContext from "../../../context/AuthContext";

const {Column, HeaderCell, Cell, Pagination} = Table;

const validationSchema = yup.object({
    numeroPoliza: yup
        .string('Ingrese el numero de poliza')
        .min(7, 'La poliza debe tener al menos 7 numeros')
        .required('Ingrese un numero valido'),
});
const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const NameCell = ({rowData, dataKey, ...props}) => {
    switch (dataKey) {
        case 'Afinidad':
            return (
                <Cell {...props}>
                    {rowData.AfinidadInfo?.[0]?.Nombre ?? '—'}
                </Cell>
            );
        case 'ClienteNombre':
            return (
                <Cell {...props}>
                    {rowData.emision_clientes[0].Cliente.nombre + " " + rowData.emision_clientes[0].Cliente.apellido}
                </Cell>
            );
        case 'DNI':
            return (
                <Cell {...props}>
                    {rowData.emision_clientes[0].Cliente.dni}
                </Cell>
            );
        case 'Patente':
            return (
                <Cell {...props}>
                    {rowData.vehiculo.patente}
                </Cell>
            );
        case 'Modelo':
            return (
                <Cell {...props}>
                    {(rowData.vehiculo.detalle_marca ?? rowData.vehiculo.marca) + " " + (rowData.vehiculo.detalle_version ?? (rowData.vehiculo.InfoMoto.Modelo + " " + `(Codia: ${rowData.vehiculo.modelo})`))}
                </Cell>
            );
    }
};

const GET_EMISIONES = gql`
    query MyQuery {
      Motovehiculo_Emision(where: {environment: {_eq: "pro"}, estado: {_neq: "Cancel"}}, order_by: {idEmision: desc}) {
        vehiculo {
          marca
          detalle_marca
          detalle_version
          patente
          modelo
          InfoMoto {
            Modelo
          }
        }
        estado
        formaDePago
        numeroPoliza
        numeroReferencia
        numeroTramite
        emision_clientes {
          Cliente {
            dni
            nombre
            apellido
          }
        }
        idEmision
        AfinidadInfo {
          Nombre
        }
      }
    }
`;


const CONFIRMAR_EMISION = gql`
    mutation confirmarEmision($id: Int!, $numPoliza: String!) {
      update_Motovehiculo_Emision(where: {idEmision: {_eq: $id}}, _set: {estado: "Success", numeroPoliza: $numPoliza}) {
        affected_rows
      }
    }`;


const useStyles = makeStyles(theme => ({
    table: {
        marginTop: theme.spacing(3),
        backgroundColor: "#fff",
        borderRadius: "20px",
        boxShadow: "5px 10px 18px #888888",
        padding: "30px"
    },
    alertField: {
        '& label.Mui-focused': {
            color: "#BB0D66",
        },
    },
    alertTitle: {
        fontFamily: "EncodeSansBold",
        color: "#BB0D66",
        fontSize: "18px"
    },
    alertSubTitle: {
        fontFamily: "EncodeSansBold",
        color: "#000",
        lineHeight: 0.5,
        fontSize: "16px"
    },
    alertText: {
        fontFamily: "EncodeSansRegular",
        color: "#000",
        fontSize: "16px"
    },
    buttons: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        width: "100%",
        padding: "8px 0px"
    },
    buttonConfirm: {
        borderRadius: "30px",
        color: "#fff",
        fontSize: "16px",
        backgroundColor: "#BB0D66",
        marginLeft: "5px",
        marginRight: "5px",
        border: "solid #BB0D66 0px",
        '&:hover': {
            backgroundColor: "#000000",
        },
    },
    buttonCancel: {
        borderRadius: "30px",
        color: "#fff",
        fontSize: "16px",
        backgroundColor: "#9A9A9A",
        marginLeft: "5px",
        marginRight: "5px",
        border: "solid #BB0D66 0px",
        '&:hover': {
            backgroundColor: "#000000",
        },
    },
    centerVertically: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: "center",
    },
    endHorizontally: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: "flex-end",
        alignItems: "center",
    },
    snackBar: {
        backgroundColor: theme.palette.warning.dark
    },
}))

function TablaEmisionesMotovehiculo() {
    const classes = useStyles();

    const [getEmisionesData, {data: emisionesData, refetch}] = useLazyQuery(GET_EMISIONES, {
        fetchPolicy: 'network-only',
    });

    //DIALOG
    const [id, setId] = useState('');
    const [tramite, setTramite] = useState('');
    const [rows, setRows] = useState(null);
    const [filteredEmisiones, setFilteredEmisiones] = useState(null);
    const [isDownloading, setIsDownloading] = useState(false);

    //SNACKBAR ALERT
    const [openSnackBar, setOpenSnackBar] = useState(false);
    const [alertMessageSnackBar, setAlertMessageSnackBar] = useState(null);

    //ALERT DELETE
    const [openAlertDelete, setOpenAlertDelete] = useState(false);
    const handleCloseAlertDelete = () => {
        setOpenAlertDelete(false);
    };
    const handleOpenAlertDelete = (row) => {
        setId(row.idEmision);
        setTramite(row.NumeroTramite);
        setOpenAlertDelete(true);
    };

    //PAGINATION
    const [page, setPage] = useState(1);
    const [displayLength, setDisplayLength] = useState(10);

    //ALERT CONFIRM
    const [openAlertConfirm, setOpenAlertConfirm] = useState(false);
    const handleCloseAlertConfirm = () => {
        setOpenAlertConfirm(false);
    };
    const handleOpenAlertConfirm = (row) => {
        setId(row.idEmision);
        setTramite(row.numeroTramite);
        setOpenAlertConfirm(true);
    };

    //CONFIRM AND CANCEL
    const [confimarEmisionMotovehiculo] = useMutation(CONFIRMAR_EMISION);
    const formik = useFormik({
        initialValues: {
            numeroPoliza: '',
        },
        validationSchema: validationSchema,
        onSubmit: async (numeroPoliza) => {
            setRows(null)
            await confimarEmisionMotovehiculo({variables: {id: id, numPoliza: numeroPoliza.numeroPoliza}})
            setOpenAlertConfirm(false)
            await refetch();
        },
    });

    //SEARCH
    const handleSearchValueChange = (event) => {
        if (event.target.value.length >= 3) {
            let filtered = rows.filter((item) =>
                item["vehiculo"]["patente"].toUpperCase().includes(event.target.value.toUpperCase())
                || item["emision_clientes"][0]["Cliente"]["apellido"].toUpperCase().includes(event.target.value.toUpperCase())
                || item["numeroReferencia"].toUpperCase().includes(event.target.value.toUpperCase())
                || item["numeroTramite"].toUpperCase().includes(event.target.value.toUpperCase())
                || item["emision_clientes"][0]["Cliente"]["nombre"].toUpperCase().includes(event.target.value.toUpperCase())
                || (item["AfinidadInfo"]?.[0]?.Nombre ?? "").toUpperCase().includes(event.target.value.toUpperCase())
                || item["emision_clientes"][0]["Cliente"]["dni"].toUpperCase().includes(event.target.value.toUpperCase())
                || item["vehiculo"]["InfoMoto"]["Modelo"].toUpperCase().includes(event.target.value.toUpperCase())
                || item["vehiculo"]["marca"].toUpperCase().includes(event.target.value.toUpperCase())
            );
            setFilteredEmisiones(filtered);
        } else setFilteredEmisiones(null)
    };

    //DOWNLOAD
    const openInNewTab = (url) => {
        const newWindow = window.open(url, '_blank', 'noopener,noreferrer');
        if (newWindow) newWindow.opener = null
    };

    const {authToken} = useContext(authContext)

    const handleDownload = (option, rowData) => {
        setIsDownloading(true)
        let url = process.env.REACT_APP_BACK_SERVER + '/documentacion/motovehiculo';
        let body = {
            "origen": 'affinity',
            "document": option,
            "officialNumber": rowData['numeroPoliza'],
            "referenceNumber": rowData['numeroReferencia']
        };
        let headers = {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${authToken}`,
        };

        Axios.post(url, body, {headers: headers}
        ).then(res => {
            openInNewTab(res.data)
            setIsDownloading(false)
        }).catch(err => {
            setOpenSnackBar(true)
            setAlertMessageSnackBar("Ha ocurrido un error, intente más tarde")
            setIsDownloading(false)
        });

    };

    //TABLE RENDER
    const renderMenu = (rowData) => {
        const handleSelect = eventKey => {
            switch (eventKey) {
                case 0:
                    handleOpenAlertConfirm(rowData)
                    break;
                case 1:
                    handleOpenAlertDelete(rowData)
                    break;
                case 2.1:
                    handleDownload("Caratula", rowData);
                    break;
                case 2.2:
                    handleDownload("ReciboConCodigoDeBarra", rowData);
                    break;
                case 2.3:
                    handleDownload("Factura", rowData);
                    break;
                case 2.4:
                    handleDownload("ConstanciaDeCoberturaPE", rowData);
                    break;
                case 2.5:
                    handleDownload("ConstanciaCoberturaRC", rowData);
                    break;
            }

        };
        if (rowData.estado === 'Success')
            return (
                <Popover full>
                    <Dropdown.Menu onSelect={handleSelect}>
                        {/*<Dropdown.Item eventKey={1}>Cancelar</Dropdown.Item>*/}
                        {/*<Dropdown.Item divider/>*/}
                        <Dropdown.Menu title="Descargar">
                            <Dropdown.Item eventKey={2.1}>Póliza</Dropdown.Item>
                            {rowData.formaDePago === "0" //Efectivo
                                ? <Dropdown.Item eventKey={2.2}>Cupón de Pago</Dropdown.Item>
                                : <Dropdown.Item eventKey={2.3}>Factura</Dropdown.Item>}
                            <Dropdown.Item onSelect={handleSelect} eventKey={2.4}>Certificado de Cobertura</Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown.Menu>

                </Popover>
            );
        else
            return (
                <Popover full>
                    <Dropdown.Menu onSelect={handleSelect}>
                        <Dropdown.Item eventKey={0}>Confirmar</Dropdown.Item>
                        {/*<Dropdown.Item eventKey={1}>Cancelar</Dropdown.Item>*/}
                        <Dropdown.Item divider/>
                        <Dropdown.Menu title="Descargar" placement="bottomStart">
                            <Dropdown.Item onSelect={handleSelect} eventKey={2.5}>Certificado de Cobertura Provisoria</Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown.Menu>

                </Popover>
            );
    };

    const ActionCell = ({rowData, dataKey, ...props}) => {
            return (
                <Cell {...props} className="link-group">
                    <Whisper placement="autoVerticalStart" trigger="click" speaker={renderMenu(rowData)}>
                        <ArrowDropDownCircleIcon style={{color: "#BB0D66", cursor: "pointer"}}/>
                    </Whisper>
                </Cell>
            );
        }
    ;
    const getData = () => {
        return rows.filter((v, i) => {
            const start = displayLength * (page - 1);
            const end = start + displayLength;
            return i >= start && i < end;
        });
    };

    useEffect(() => {
        getEmisionesData()
    }, []);

    useEffect(() => {
        if (emisionesData) {
            if (filteredEmisiones === null)
                setRows(emisionesData["Motovehiculo_Emision"]);
            else
                setRows(filteredEmisiones);
        }
    }, [filteredEmisiones, emisionesData]);

    if (!rows) return (<Loading/>);
    return (
        <Fragment>
            <div className={classes.table}>
                <div className={classes.endHorizontally} style={{marginRight: "48px", padding: "8px 0px"}}>
                    <div className={classes.centerVertically} style={{marginRight: "8px"}}><SearchIcon
                        style={{color: "#BB0D66"}}/></div>
                    <div className={classes.centerVertically} style={{marginTop: "-24px"}}>
                        <TextField
                            label="Buscar"
                            className={classes.alertField}
                            onChange={(e) => handleSearchValueChange(e)}/>
                    </div>
                </div>
                <Table
                    height={400}
                    width={1000}
                    data={getData()}
                >
                    <Column fixed width={50}>
                        <HeaderCell>ID</HeaderCell>
                        <Cell dataKey="idEmision"/>
                    </Column>
                    <Column width={90}>
                        <HeaderCell>Estado</HeaderCell>
                        <Cell dataKey="estado"/>
                    </Column>
                    <Column width={100}>
                        <HeaderCell>Afinidad</HeaderCell>
                        <NameCell dataKey="Afinidad"/>
                    </Column>

                    <Column width={110}>
                        <HeaderCell>N° de referencia</HeaderCell>
                        <Cell dataKey="numeroReferencia"/>
                    </Column>
                    <Column width={200}>
                        <HeaderCell>N° de trámite</HeaderCell>
                        <Cell dataKey="numeroTramite"/>
                    </Column>
                    <Column width={200}>
                        <HeaderCell>Modelo</HeaderCell>
                        <NameCell dataKey="Modelo"/>
                    </Column>
                    <Column width={90}>
                        <HeaderCell>Patente</HeaderCell>
                        <NameCell dataKey="Patente"/>
                    </Column>
                    <Column width={90}>
                        <HeaderCell>DNI</HeaderCell>
                        <NameCell dataKey="DNI"/>
                    </Column>
                    <Column width={200}>
                        <HeaderCell>Nombre</HeaderCell>
                        <NameCell dataKey="ClienteNombre"/>
                    </Column>
                    <Column fixed="right" width={70} align="center">
                        <HeaderCell>Opciones</HeaderCell>
                        <ActionCell dataKey="id"/>
                    </Column>
                </Table>

                <div style={{padding: 20}}>
                    <Pagination
                        lengthMenu={[
                            {
                                value: 10,
                                label: 10
                            },
                            {
                                value: 20,
                                label: 20
                            }
                        ]}
                        activePage={page}
                        displayLength={displayLength}
                        total={rows.length}
                        onChangePage={(dataKey) => setPage(dataKey)}
                        onChangeLength={(dataKey) => setDisplayLength(dataKey)}
                    />
                </div>

                {openAlertConfirm && (
                    <Dialog open={openAlertConfirm} onClose={handleCloseAlertConfirm}
                            aria-labelledby="form-dialog-title">
                        <DialogTitle>
                            <p className={classes.alertTitle}>Confirmar Emisión</p>
                        </DialogTitle>
                        <form onSubmit={formik.handleSubmit}>
                            <DialogContent>
                                <DialogContentText>
                                    <p className={classes.alertSubTitle}>ID Emisión seleccionado: <span
                                        className={classes.alertText}>{id}</span></p>
                                    <br/>
                                    <p className={classes.alertSubTitle}>Número de referencia: <span
                                        className={classes.alertText}>{tramite}</span></p>
                                </DialogContentText>

                                <TextField
                                    autoFocus
                                    margin="dense"
                                    className={classes.alertField}
                                    id="numeroPoliza"
                                    label="Número de Póliza"
                                    type="numeroPoliza"
                                    fullWidth
                                    value={formik.values.NumeroPoliza}
                                    error={formik.touched.NumeroPoliza && Boolean(formik.errors.NumeroPoliza)}
                                    helperText={formik.touched.NumeroPoliza && formik.errors.NumeroPoliza}
                                    onChange={formik.handleChange}
                                />

                            </DialogContent>
                            <DialogActions>
                                <div className={classes.buttons}>
                                    <Button onClick={handleCloseAlertConfirm} className={classes.buttonCancel}>
                                        Atrás
                                    </Button>
                                    <Button type="submit"
                                            className={classes.buttonConfirm}>
                                        Confirmar Emisión
                                    </Button>
                                </div>
                            </DialogActions>
                        </form>
                    </Dialog>
                )}
                {isDownloading && <div style={{position: "absolute", top: "10%", left: "50%"}}><Loading/></div>}
                <Snackbar open={openSnackBar && alertMessageSnackBar} autoHideDuration={5000} onClose={() => {
                    setOpenSnackBar(false);
                    setAlertMessageSnackBar(null);
                }}>
                    <Alert onClose={() => {
                        setOpenSnackBar(false);
                        setAlertMessageSnackBar(null);
                    }} severity="warning" elevation={6} variant="filled"
                           classes={{filledWarning: classes.snackBar}}
                    >
                        {alertMessageSnackBar}
                    </Alert>
                </Snackbar>
            </div>
        </Fragment>
    )
}

export default withRoot(TablaEmisionesMotovehiculo);
